import { render, staticRenderFns } from "./updatePTLO.vue?vue&type=template&id=0c800d29&lang=pug&"
import script from "./updatePTLO.vue?vue&type=script&lang=js&"
export * from "./updatePTLO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports